import { createContext, useState } from "react";

export enum TransactionResourceType {
	PURCHASE = "PURCHASE",
	SALES = "SALES",
	TRANSFER = "TRANSFER",
	STOCKTAKING = "STOCKTAKING",
	PRODUCT = "PRODUCT",
	UNSET = "",
}

interface TransactionContextType {
	listItemId: string;
	setListItemId: (listItemId: string) => void;
	transactionResourceType: TransactionResourceType;
	setTransactionResourceType: (transactionResourceType: TransactionResourceType) => void;
}

export const TransactionContext = createContext<TransactionContextType>({
	listItemId: "",
	setListItemId: (listItemId: string) => {},
	transactionResourceType: TransactionResourceType.UNSET,
	setTransactionResourceType: (transactionResourceType: TransactionResourceType) => {},
});

const TransactionContextProvider = (props: { children: JSX.Element }) => {
	const [listItemId, setListItemId] = useState<string>("");
	const [transactionResourceType, setTransactionResourceType] = useState<TransactionResourceType>(
		TransactionResourceType.UNSET
	);

	const transactionContextValues = {
		listItemId,
		setListItemId,
		transactionResourceType,
		setTransactionResourceType,
	};

	return <TransactionContext.Provider value={transactionContextValues}>{props.children}</TransactionContext.Provider>;
};

export default TransactionContextProvider;
